import { Component, OnInit,EventEmitter } from '@angular/core';
import {ListingService } from '../listing.service';
import { ActivityService } from '../../common/activity.service'
import { PackageService } from '../../common/package.service'
import { CreditService } from '../../common/credit.service';
import { CountryService } from '../../common/country.service';
import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-attendee-edit-activity',
  templateUrl: './attendee-edit-activity.component.html',
  styleUrls: ['./attendee-edit-activity.component.css','../admin.css', '../../app.component.css'],
  providers : [ ActivityService , PackageService, CreditService, ListingService, CountryService ]

})
export class AttendeeEditActivityComponent implements OnInit {

  public eventId: any;
  mainUser:any;
  billingStates:any;
  attId:any;
  public event: any;
  public packageId: any;
  public activities: any=[];
  public activity: any;
  public users = [];
  public onSave = new EventEmitter();
  public onClose = new EventEmitter();
  public freeActivities = [];
  public spinner: boolean = false;
  public userIndex = 0;
  public currentActivity = 0;
  payType = 'Card';
  balance=0;
  creditCard = {
    cardId : 0,
    name : '',
    number : '',
    expMonth : '',
    expYear : '',
    cvv : '',
    type : undefined,
    save : false,
    existing : true
  };
  billingAddress = {
    name : '',
    line1 : '',
    line2 : '',
    city : '',
    stateId : '',
    state : '',
    countryId : '',
    country : '',
    zipcode : '',
    sameAsUser : false
  };
  countries = [];
  states = [];
  cards = [];
  formChanged:boolean = false;
  eventUserId:any;


  constructor(private activityService: ActivityService, private packageService: PackageService, private creditService: CreditService, private listingService: ListingService, private snackBar: MdSnackBar, private countryService: CountryService) { }

  ngOnInit() {
  }


  initiate(){
    this.activityService.getActivities(this.eventId).subscribe(response => {
      this.activities = response;
      for(var i=0;i<this.activities.length;i++)
        this.activities[i].freeCount = 0;
      this.packageService.getActivityLimits({packageId:this.packageId}).subscribe(response1 => {
        this.freeActivities = [];
        for(var i=0;i<response1.length;i++)
          for(var j=0;j<this.activities.length;j++)
            if(response1[i].activityId==this.activities[j].id)
            {
              this.activities[j].freeCount = response1[i].freeCount;
              if(parseInt(this.activities[j].freeCount))
                this.freeActivities.push(this.activities[j]);
              break;
            }
      });
    });
    this.countryService.getCountries().subscribe(response => {
      this.countries = response;
      for(var i=0;i<this.countries.length;i++)
        if(this.countries[i].name=='USA')
        {
          this.billingAddress.countryId = this.countries[i].id;
          this.billingCountryChanged();
        }
    });
  }

  activitySelected(userActivity){
    this.spinner = true;
    this.formChanged = true;
    userActivity.price = 0.00;
    userActivity.userQuestions = [];
    userActivity.questions = [];
    var usedCount = 0;
    var price = 0.00;
    var freeCount = 0;
    for(var i=0;i<this.activities.length;i++)
      if(this.activities[i].id==userActivity.activityId)
      {
        userActivity.activityName = this.activities[i].name;
        price = parseFloat(this.activities[i].price);
        freeCount = this.activities[i].freeCount;
        break;
      }
    for(var i=0;i<this.users.length;i++)
    {
      //for(var j=0;j<this.users[i].eventUser.userActivities.length;j++)
      if(!this.users[i].deleted && this.users[i].eventUser.userActivity.activityId==userActivity.activityId && (this.users[i].eventUser.userActivity.totalPrice==0 || this.userIndex==i))
        usedCount+=1;
    }
    if(usedCount>freeCount || freeCount==0)
    {
      userActivity.price = price;
      userActivity.totalPrice = price;
    }
    else
    {
      userActivity.price = 0;
      userActivity.totalPrice = 0;
    }
    this.activityService.getActivityQuestionsWithOptions({activityId:userActivity.activityId}).subscribe(
            response => {
          this.spinner = false;
          userActivity.questions = response;
          userActivity.userQuestions = [];
          for(var i=0;i<userActivity.questions.length;i++)
          {
            userActivity.questions[i].isMandatory = parseInt(userActivity.questions[i].isMandatory);
            userActivity.userQuestions.push({id:'', userId:userActivity.userId, questionId:userActivity.questions[i].id, answerId:0, answerText:'', transId:'123', price:0});
            for(var j=0;j<userActivity.questions[i].options.length;j++)
            {
              userActivity.questions[i].options[j].isPrice = parseInt(userActivity.questions[i].options[j].isPrice);
              for(var k=0;k<userActivity.questions[i].options[j].questions.length;k++)
              {
                userActivity.questions[i].options[j].questions[k].isMandatory = parseInt(userActivity.questions[i].options[j].questions[k].isMandatory);
                for(var l=0;l<userActivity.questions[i].options[j].questions[k].options.length;l++)
                  userActivity.questions[i].options[j].questions[k].options[l].isPrice = parseInt(userActivity.questions[i].options[j].questions[k].options[l].isPrice);
              }
            }
          }
        },
            error => {
          this.spinner = false;
        }
    );
  }

  activityFee(i){
    if(!this.users[i] || !this.activities)
      return '0.00';
    var usedCount = 0;
    var price = 0.00;
    var freeCount = 0;
    for(var j=0;j<this.activities.length;j++)
    {
      if(this.activities[j].id==this.users[i].eventUser.userActivity.activityId)
      {
        this.users[i].eventUser.userActivity.activityName = this.activities[j].name;
        price = parseFloat(this.activities[j].price);
        freeCount = this.activities[j].freeCount;
        break;
      }
    }
    for(var j=0;j<this.users.length;j++)
    {
      if(!this.users[j].deleted && this.users[i].eventUser.userActivity.activityId==this.users[j].eventUser.userActivity.activityId && (this.users[j].eventUser.userActivity.totalPrice==0 || this.userIndex==i))
        usedCount+=1;
    }
    var price = (usedCount>freeCount||freeCount==0 ? parseFloat(this.users[i].eventUser.userActivity.price) : 0.00);
    for(var i1=0;i1<this.users[i].eventUser.userActivity.userQuestions.length;i1++)
    {
      price += (usedCount>freeCount||freeCount==0 ? parseFloat(this.users[i].eventUser.userActivity.userQuestions[i1].price) : 0.00);
      for(var j=0;j<this.users[i].eventUser.userActivity.questions[i1].options.length;j++)
      {
        if(this.users[i].eventUser.userActivity.questions[i1].options[j].userQuestions)
          for(var k=0;k<this.users[i].eventUser.userActivity.questions[i1].options[j].userQuestions.length;k++)
            price += (usedCount>freeCount||freeCount==0 ? parseFloat(this.users[i].eventUser.userActivity.questions[i1].options[j].userQuestions[k].price) : 0.00);
      }
    }
    this.users[i].eventUser.userActivity.totalPrice = price;
    return price.toFixed(2);
  }

  optionSelected(params){
    this.formChanged = true;
    for(var i=0;i<params.question.options.length;i++)
    {
      if(params.question.options[i].id==params.optionId && (params.userActivity.userQuestions[params.questionIndex].answerId==params.optionId || params.question.options[i].selected))
      {
        params.question.options[i].userQuestions = [];
        for(var j=0;j<params.question.options[i].questions.length;j++)
          params.question.options[i].userQuestions.push({id:'', userId:params.userActivity.userId, questionId:params.question.options[i].questions[j].id, answerId:0, answerText:'', transId:'123', price:0});
      }
    }
    if(parseInt(params.userActivity.price)>0)
      this.setPrice(params);
    else
      params.userActivity.userQuestions[params.questionIndex].price = 0.00;
  }

  setPrice(params){
    params.userActivity.userQuestions[params.questionIndex].price = 0.00;
    for(var i=0;i<params.question.options.length;i++)
    {
      if(params.question.options[i].userQuestions)
        for(var j=0;j<params.question.options[i].userQuestions.length;j++)
          params.question.options[i].userQuestions[j].price = 0.00;
      if(params.userActivity.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
      {
        if(params.question.options[i].isPrice)
        {
          if(params.question.answerType=='Radio')
            params.userActivity.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if(params.question.answerType=='Check')
            params.userActivity.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  subOptionSelected(params){
    this.formChanged = true;
    if(parseInt(params.userActivity.price)>0)
      this.setSubPrice(params)
    else
      params.option.userQuestions[params.questionIndex].price = 0.00;
  }

  setSubPrice(params){
    params.option.userQuestions[params.questionIndex].price = 0.00;
    for(var i=0;i<params.question.options.length;i++)
    {
      if(params.option.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
      {
        if(params.question.options[i].isPrice)
        {
          if(params.question.answerType=='Radio')
            params.option.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
          else if(params.question.answerType=='Check')
            params.option.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
        }
      }
    }
  }

  changeActivity(){
    this.spinner = true;
    this.creditCard.type = this.cardType();
    this.activityFee(this.userIndex);
    this.listingService.changeAttendeeActivity({ user:this.users[this.userIndex], creditCard:this.creditCard, payType:this.payType, event:this.event ,billingAddress:this.billingAddress}).subscribe(
            response => {
          this.spinner = false;
          if(response.status)
          {
            this.snackBar.open('Activity Changed Successfully','',{duration:4000});
            this.onSave.emit();
          }
          else
            this.snackBar.open(response.msg,'',{duration:4000});
        },
            error => {
          this.spinner = false;
          this.snackBar.open(error,'',{duration:4000});
        }
    );
  }

  activityFormValid(frm){
    var flag = true;
    if(!frm.valid)
      flag = false;
    if(flag && !this.formChanged)
      flag = false;
    if(flag && this.users[this.userIndex].eventUser.userActivity.totalPrice>0)
    {
      if(this.payType=='Card' && !this.creditCard.existing)
      {
        if(flag && !this.validateDigit(this.creditCard.number,14,19))
          flag = false;
        if(flag && !this.validateDigit(this.creditCard.cvv,3,4))
          flag = false;
        if(flag && !this.billingAddress.line1)
          flag = false;
        if(flag && !this.billingAddress.city)
          flag = false;
        if(flag && !this.billingAddress.stateId)
          flag = false;
        if(flag && !this.validateZip(this.billingAddress.zipcode,this.billingAddress.country))
          flag = false;
        if(flag && !this.billingAddress.countryId)
          flag = false;
      }
      else if(this.payType=='Card' && this.creditCard.existing)
      {
        if(flag && this.creditCard.cardId<=0)
          flag = false;
      }
    }
    if(flag)
    {
      for(var i=0;i<this.users[this.userIndex].eventUser.userActivity.questions.length;i++)
      {
        if(!flag)
          break;
        if(this.users[this.userIndex].eventUser.userActivity.questions[i].isMandatory==1 && (this.users[this.userIndex].eventUser.userActivity.questions[i].answerType=='TextField' || this.users[this.userIndex].eventUser.userActivity.questions[i].answerType=='Radio') && !(this.users[this.userIndex].eventUser.userActivity.userQuestions[i].answerText || this.users[this.userIndex].eventUser.userActivity.userQuestions[i].answerId>0))
          flag = false;
        for(var j=0;j<this.users[this.userIndex].eventUser.userActivity.questions[i].options.length;j++)
        {
          if(!flag)
            break;
          if(this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].id!=this.users[this.userIndex].eventUser.userActivity.userQuestions[i].answerId)
            continue;
          for(var k=0;k<this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].questions.length;k++)
          {
            if(!flag)
              break;
            if(!this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].userQuestions[k])
              continue;
            if(this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].questions[k].isMandatory==1 && (this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].questions[k].answerType=='TextField' || this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].questions[k].answerType=='Radio') && !(this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].userQuestions[k].answerText || this.users[this.userIndex].eventUser.userActivity.questions[i].options[j].userQuestions[k].answerId>0))
              flag = false;
          }
        }
      }
    }
    return flag;
  }



  cardType(){
    return this.creditService.parseCardType(this.creditCard.number);
  }

  validateDigit(num,min,max){
    return num.match("^[0-9]{"+min+","+max+"}$");
  }

  billingSameAsUser(){
    this.spinner = true;
    if(this.billingAddress.sameAsUser)
    {
      this.billingAddress.name = this.users[0].eventUser.companyName;
      this.billingAddress.line1 = this.users[0].eventUser.addressLine1;
      this.billingAddress.line2 = this.users[0].eventUser.addressLine2;
      this.billingAddress.city = this.users[0].eventUser.city;
      this.billingAddress.stateId = this.users[0].eventUser.stateId;
      this.billingAddress.state = this.users[0].eventUser.stateName;
      this.billingAddress.countryId = this.users[0].eventUser.countryId;
      this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
              response => {
            this.spinner = false;
            this.billingStates = response;
          },
              error => {
            this.spinner = false;
          }
      );
      this.billingAddress.country  = this.users[0].eventUser.countryName;
      this.billingAddress.zipcode = this.users[0].eventUser.zipcode;
    }
    else
    {
      this.spinner = false;
      this.billingAddress.name = '';
      this.billingAddress.line1 = '';
      this.billingAddress.line2 = '';
      this.billingAddress.city = '';
      this.billingAddress.stateId = '';
      this.billingAddress.state = '';
      this.billingAddress.countryId = '';
      this.billingAddress.country = '';
      this.billingAddress.zipcode = '';
    }
  }

  billingStateChanged(){
    for(var i=0;i<this.billingStates.length;i++)
      if(this.billingStates[i].id==this.billingAddress.stateId)
        this.billingAddress.state = this.billingStates[i].name;
  }

  billingCountryChanged(){
    this.spinner = true;
    this.countryService.getStates(this.billingAddress.countryId).subscribe(
            response => {
          this.spinner = false;
          this.billingStates = response;
        },
            error => {
          this.spinner = false;
          this.snackBar.open(error,'',{duration:4000});
        }
    );
    for(var i=0;i<this.countries.length;i++)
      if(this.countries[i].id==this.billingAddress.countryId)
        this.billingAddress.country = this.countries[i].name;
  }


  validateZip(zip,country){
    return true;
    // if(country=='Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }

  reset(){
    this.onClose.emit();
  }


}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/attendee-edit-activity/attendee-edit-activity.component.ts